'use strict';

define('lib/analytics/blocks/dealer.block',[], function () {
  // dealer.dataLayer contained link_text, making it all worthless
  return function dealerBlock(dealer) {
    // right now, when dealers are run through transforms/dealer.tmpl.common xform
    // it gets an dataLayer. If thats the case, just return it
    // otherwise it will need to be built
    var providedDl = dealer.dataLayer;
    if (providedDl && providedDl.link_text) {
      delete providedDl.link_text;
    }

    return providedDl || {
      dealer_brand: dealer.dealer_brand || 'Toyota',
      dealer_code: dealer.dealer_code,
      dealer_name: dealer.dealer_name,
      dealer_zipcode: dealer.dealer_zipcode,
      dealer_city: dealer.dealer_city,
      dealer_state: dealer.dealer_state,
      dealer_metro: dealer.dealer_metro
      // dealer_has_txm: null,
      // dealer_has_espanol: null,
      // 'dealer_has_tire-center': null,
      // dealer_has_schedule_service: 'No',
      // dealer_has_service_only: 'No',
    };
  };
});

